export interface PromotionalBadgesProps {
  innerPage: string
  design?: boolean
  onClick?: (path: string) => void
  onNavigateBack?: () => void
}

export enum PROMOTIONAL_BADGE {
  FIRST_PRIORITY = 'first-priority',
  SECOND_PRIORITY = 'second-priority',
  THIRD_PRIORITY = 'third-priority',
}
